import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";

const Section6Text78a = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    houseAreaAccordingTasritTaba,
  } = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(houseAreaAccordingTasritTaba) && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={styles.bold}>שטח בהתאם לתשריט תב"ע: </span>
          <span>{getBreakLinesTextShumaType3(houseAreaAccordingTasritTaba)}</span>
        </div>
      )}
    </div>
  )
});

export default Section6Text78a;
